import client from "./client.js";

/**
 * Fetch a page of audit log entries.
 *
 * @param {Object} params
 * @param {string} [params.actor_id]
 * @param {string} [params.action]
 * @param {string} [params.resource_type]
 * @param {string} [params.resource_id]
 * @param {string} [params.date_from]   — ISO 8601
 * @param {string} [params.date_to]     — ISO 8601
 * @param {string} [params.cursor]
 * @param {number} [params.limit]
 */
export async function fetchAuditLogs(params = {}) {
  const res = await client.get("/audit-logs", { params });
  return res.data; // { data: [...], meta: { has_next, next_cursor, limit } }
}
